import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { getTextWidth } from '../../common/utils';
import GlobalSearchUtils from '../globalSearchUtils';
var MAX_CUTTING_LOOPS = 10000;
export var WordHighlighter = function (_a) {
    var searchTerm = _a.searchTerm, className = _a.className, text = _a.text;
    var ref = useRef(null);
    var _b = useState(''), cutText = _b[0], setCutText = _b[1];
    var shownText = cutText || text;
    useEffect(function () {
        if (ref.current) {
            var _a = window.getComputedStyle(ref.current), paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight;
            var wrapperWidth = ref.current.clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
            var fullText = ref.current.querySelector('.globalSearchHighlighter__hiddenText');
            var highlightedText = fullText.querySelector('mark');
            // don't continue if there is not highlighted text
            if (!highlightedText) {
                if (cutText) {
                    setCutText('');
                }
                return;
            }
            // the width of full text in px
            var fullTextWidth = fullText.offsetWidth;
            // the position of right border of first highlighted text
            var endOfHighlightedText = highlightedText.offsetLeft + highlightedText.offsetWidth;
            // the space which must be visible after highlighted text, when the highlighted text is moved to visible part,
            var spaceAfterHighlightedText = Math.min(fullTextWidth - endOfHighlightedText, 130);
            // cut the beginning of text, if the highlighted text is not fully visible or there is not visible +-15 chars after
            if (endOfHighlightedText + spaceAfterHighlightedText > wrapperWidth) {
                var lettersToCutCount = 0;
                // space needed to be cut from the text in order to make highlighted text visible. 35 is magic offset to place text correctly
                var spaceToCut = endOfHighlightedText - wrapperWidth + spaceAfterHighlightedText + 35;
                // find out how many chars need to be cut in order to make highlighted text visible
                while (getTextWidth('...' + text.slice(0, lettersToCutCount), fullText) < spaceToCut && lettersToCutCount < MAX_CUTTING_LOOPS) {
                    lettersToCutCount += 1;
                }
                setCutText('...' + text.slice(lettersToCutCount));
            }
            else {
                setCutText('');
            }
        }
    }, [searchTerm, text]);
    return (React.createElement("div", { className: "globalSearchHighlighter " + className, ref: ref },
        React.createElement(Highlighter, { className: 'globalSearchHighlighter__hiddenText', textToHighlight: text, searchWords: searchTerm.split(' '), findChunks: GlobalSearchUtils.findChunksAtBeginningOfWords }),
        React.createElement(Highlighter, { className: 'globalSearchHighlighter__visibleText', textToHighlight: shownText, searchWords: searchTerm.split(' '), findChunks: GlobalSearchUtils.findChunksAtBeginningOfWords })));
};
export default WordHighlighter;
//# sourceMappingURL=WordHighlighter.js.map